// extracted by mini-css-extract-plugin
export default {"root":"PlasmicRadialChartCompanySentiment_root__9jzBS","img__cCEnP":"PlasmicRadialChartCompanySentiment_img__cCEnP__EWdNI"};